/**
 * Get a cookie by name
 * @param {string} name - Name of the cookie to fetch
 * @returns {string|undefined} Cookie value or undefined if not found
 */
const getCookie = name => {
  const search = `${name}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookieArr = decodedCookie.split(';')

  for (let i = 0, len = cookieArr.length; i < len; i++) {
    const cookie = cookieArr[i].trim()

    if (cookie.indexOf(search) === 0) {
      return cookie.substring(search.length, cookie.length)
    }
  }

  return
}

module.exports = getCookie
